<app-wizard-step-wrapper
  [showStep]="showStep"
  [stepTitle]="stepMetadata.stepName"
  [formGroup]="formStep"
  >
  @if (!isMobile) {
    <div class="step-container id-app-access">
      <h3 class="form-step__subheading">
        <span data-private>{{ user?.firstName }}</span
          >, please open the Clear Sign ID scanner to scan your ID with your phone or tablet camera.
        </h3>
        <div class="id-app-access-options">
          <div class="id-app-access-option">
            <div class="id-app-access-option__instructions">
              <h3 class="id-app-access-option__instructions__title">
                Option 1: Send link to your device
              </h3>
              <p class="id-app-access-option__instructions__instruction">
                Send a link to your phone or tablet. Click the link and scan your ID.
              </p>
            </div>
            <div class="id-app-access-option__action">
              <app-phone-input
                data-private
                [dataTestId]="'phone-input'"
                [errorMessage]="phoneInputErrorMessage"
                [formControlRef]="phoneNumberOverride"
                [isFullWidth]="true"
                [label]="'Phone Number'"
                [maskOverride]="'(XXX) XXX-0000'"
                (click)="clearPhoneNumberIfDefault()"
                (keypress)="clearPhoneNumberIfDefault()"
              ></app-phone-input>
              <app-button
                type="primary"
                (buttonClick)="sendAccessLinkSms()"
                [dataTestId]="'id-app-access-send-link'"
                >
                {{ sendAccessLinkSmsButtonText }}
              </app-button>
              <div class="success-message">
                @if (hasAccessLinkSmsSentSuccessfully) {
                  <p>Link successfully sent</p>
                }
              </div>
            </div>
          </div>
          <div class="id-app-access-option">
            <div class="id-app-access-option__instructions">
              <h3 class="id-app-access-option__instructions__title">Option 2: Scan QR code</h3>
            </div>
            <div class="id-app-access-option__instructions">
              <p class="id-app-access-option__instructions__instruction">
                Use your phone's camera to scan the QR code below.
              </p>
            </div>
            <div class="id-app-access-option__action">
              <app-qr-code-image
                [url]="accessLink | async"
                size="240"
                margin="0"
                data-private
              ></app-qr-code-image>
            </div>
            <app-collapsible type="parent" class="app-access-help" [dataTestId]="'scanning-tips'">
              <div slot="title">
                <span>Scanning tips</span>
              </div>
              <app-collapsible
                title="How do I scan the QR Code?"
                type="child"
                [dataTestId]="'how-do-i-scan'"
                >
                <ol>
                  <li>Open the camera on your phone.</li>
                  <li>Select the rear facing camera.</li>
                  <li>
                    Aim your camera at the QR code until it appears on your phone screen. If your device
                    recognizes the QR code a notification will appear.
                  </li>
                  <li>Tap the notification to open the link.</li>
                </ol>
              </app-collapsible>
              <app-collapsible
                title="I don't have a QR scanner"
                type="child"
                [dataTestId]="'i-dont-have-a-scanner'"
                >
                <ol>
                  <li>
                    Open the
                    <a href="https://apps.apple.com/" target="_blank" rel="noopener">App Store</a> or
                    <a href="https://play.google.com/store/apps" target="_blank" rel="noopener"
                      >Google Play Store</a
                      >.
                    </li>
                    <li>Search for "QR scanner".</li>
                    <li>Download and install a QR scanner from the top results.</li>
                    <li>
                      Open the new QR scanner app and follow the directions on how to scan the QR code.
                    </li>
                  </ol>
                  <p>If there are no directions within the app try these steps:</p>
                  <ol>
                    <li>With the QR scanner app open the rear facing camera.</li>
                    <li>
                      Aim your camera at the QR code until it appears on your phone screen. If your device
                      recognizes the QR code a notification will appear.
                    </li>
                    <li>Tap the notification to open the link.</li>
                  </ol>
                </app-collapsible>
                <app-collapsible
                  title="Nothing is scanning"
                  type="child"
                  [dataTestId]="'nothing-scanning'"
                  >
                  <p>
                    There may be a delay when scanning with your camera - give it a moment while keeping
                    the QR code in focus.
                  </p>
                  <p>If this continues try using a different QR scanner.</p>
                </app-collapsible>
              </app-collapsible>
            </div>
          </div>
          <p class="id-app-access__support" data-testid="contact-support">
            Need help? Contact support: <app-support-phone></app-support-phone>
          </p>
          @if (shouldBypassRealId) {
            <app-button-container>
              @if (shouldBypassRealId) {
                <app-button
                  [dataTestId]="'next-button-id-qr'"
                  type="primary"
                  (buttonClick)="goToNextStep()"
                  >
                  Next
                </app-button>
              }
            </app-button-container>
          }
        </div>
      }

      @if (isMobile) {
        <div class="app-access-link step-container">
          <h3 class="form-step__subheading">
            <span data-private>{{ user?.firstName }}</span
              >, you're ready to start the ID verification process.
            </h3>
            <app-info-box imagePath="assets/images/license-front.svg" alt="front of identity document">
              <p>To complete this process you'll need your driver's license, or state ID.</p>
            </app-info-box>
            <app-button-container>
              @if (shouldBypassRealId) {
                <app-button
                  [dataTestId]="'next-button-id-qr'"
                  type="primary"
                  (buttonClick)="goToNextStep()"
                  >
                  Next
                </app-button>
              }
              @if (accessLink | async; as link) {
                <app-button
                  data-testid="start-id-verification-button"
                  type="primary"
                  (buttonClick)="navigateTo(link)"
                  >
                  Start ID Verification
                </app-button>
              }
            </app-button-container>
          </div>
        }
      </app-wizard-step-wrapper>
